var map = {
	"./404.vue": [
		"+H76",
		18
	],
	"./accounts.vue": [
		"jk0N",
		0,
		16
	],
	"./address.vue": [
		"/BUs",
		0,
		5
	],
	"./block.vue": [
		"HCKN",
		0,
		15
	],
	"./blocks.vue": [
		"1vgp",
		0,
		14
	],
	"./contract-txs.vue": [
		"LFCI",
		0,
		13
	],
	"./contract.vue": [
		"aL94",
		0,
		7
	],
	"./contracts.vue": [
		"/obG",
		0,
		12
	],
	"./dashboard.vue": [
		"0z3G",
		0,
		1
	],
	"./dip-leaderboard.vue": [
		"WNZj",
		0,
		6
	],
	"./dstaking-history.vue": [
		"GiqJ",
		0,
		11
	],
	"./dstaking.vue": [
		"cWIP",
		0,
		3
	],
	"./monitor.vue": [
		"x5Oc",
		0,
		2
	],
	"./nothing.vue": [
		"4YJR",
		17
	],
	"./tx.vue": [
		"TNam",
		0,
		4
	],
	"./txs-nrc20.vue": [
		"jE1k",
		0,
		10
	],
	"./txs-pending.vue": [
		"tnv5",
		0,
		9
	],
	"./txs.vue": [
		"2VAM",
		0,
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 20